import { securitySettingsConfig as base } from '../base';
import { securitySettingsConfig as CZ } from './CZ';
import { securitySettingsConfig as HR } from './HR';
import { securitySettingsConfig as HU } from './HU';
import { securitySettingsConfig as RO } from './RO';
import { securitySettingsConfig as SK } from './SK';

export const featureConfigMap = {
    base,
    CZ,
    HR,
    HU,
    RO,
    SK,
};
